import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import FullScreenModal from 'components/consumer/FullScreenModal';
import JBProductImage from 'components/essentials/JBImage/JBProductImage';
import IconMobileGrid1x from 'components/icons/iconMobileGrid1x';
import IconMobileGrid2x from 'components/icons/iconMobileGrid2x';
import RatioContainer from 'components/consumer/RatioContainer';
import PDPPinchToZoomGallery from 'components/consumer/PDP/PDPPinchToZoomGallery';
import ToggleTabGroup from 'components/consumer/ToggleTabGroup';
import SnackbarShowOnce from 'components/consumer/SnackbarShowOnce';
import getTabContentId from 'commons/getTabContentId';
import getTabId from 'commons/getTabId';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
import useScreen from 'hooks/useScreen';
import useJumpToSelectedGalleryPhoto from './hooks/useJumpToSelectedGalleryPhoto';
import PDPFullScreenGalleryListItem from './PDPFullScreenGalleryListItem';
const PDPFullScreenGallery = t0 => {
  const $ = _c(65);
  const {
    className: t1,
    displayShownIn: t2,
    enableCrops: t3,
    pdpIsModularBYOProduct: t4,
    initialSelectedPhotoIndex: t5,
    isEditOrder: t6,
    isOpen: t7,
    onClose,
    photos: t8,
    productName: t9,
    showGridView: t10
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const displayShownIn = t2 === undefined ? false : t2;
  const enableCrops = t3 === undefined ? true : t3;
  const pdpIsModularBYOProduct = t4 === undefined ? false : t4;
  const initialSelectedPhotoIndex = t5 === undefined ? 0 : t5;
  const isEditOrder = t6 === undefined ? false : t6;
  const isOpen = t7 === undefined ? false : t7;
  let t11;
  if ($[0] !== t8) {
    t11 = t8 === undefined ? [] : t8;
    $[0] = t8;
    $[1] = t11;
  } else {
    t11 = $[1];
  }
  const photos = t11;
  const productName = t9 === undefined ? "" : t9;
  const showGridView = t10 === undefined ? false : t10;
  const {
    isMobileOrTablet
  } = useScreen();
  const [mobileColumnsAcross, setMobileColumnsAcross] = useState(1);
  const is2MobileColumns = mobileColumnsAcross === 2;
  const [isPinchGalleryOpen, setIsPinchGalleryOpen] = useState(false);
  const [pinchGalleryIndex, setPinchGalleryIndex] = useState(0);
  const [selectedPhotoIndex, setSelectedPhotoIndex] = useState(initialSelectedPhotoIndex);
  let t12;
  let t13;
  if ($[2] !== initialSelectedPhotoIndex) {
    t12 = () => {
      setSelectedPhotoIndex(initialSelectedPhotoIndex);
    };
    t13 = [initialSelectedPhotoIndex];
    $[2] = initialSelectedPhotoIndex;
    $[3] = t12;
    $[4] = t13;
  } else {
    t12 = $[3];
    t13 = $[4];
  }
  useEffect(t12, t13);
  let t14;
  if ($[5] !== isOpen || $[6] !== selectedPhotoIndex) {
    t14 = {
      selectedPhotoIndex,
      isOpen
    };
    $[5] = isOpen;
    $[6] = selectedPhotoIndex;
    $[7] = t14;
  } else {
    t14 = $[7];
  }
  const galleryRef = useJumpToSelectedGalleryPhoto(t14);
  const [selectedDesktopTab, setSelectedDesktopTab] = useState("Listed");
  const selectedTab = isMobileOrTablet ? "Listed" : selectedDesktopTab;
  let t15;
  if ($[8] !== selectedTab || $[9] !== showGridView) {
    t15 = showGridView ? <ToggleTabGroup selectedTab={getTabId(selectedTab, "PDPFullScreenGallery")} noBottomBorder={true} size="md" aria-label="Full Screen Gallery Grid" items={["Listed", "Grid"].map(label => ({
      id: getTabId(label, "PDPFullScreenGallery"),
      label,
      contentId: getTabContentId(label, "PDPFullScreenGallery"),
      onClick: () => {
        setSelectedDesktopTab(label);
      }
    }))} /> : undefined;
    $[8] = selectedTab;
    $[9] = showGridView;
    $[10] = t15;
  } else {
    t15 = $[10];
  }
  let t16;
  if ($[11] !== productName) {
    t16 = <span className="text-sm font-bold items-center text-gray flex h-full justify-center">{productName}</span>;
    $[11] = productName;
    $[12] = t16;
  } else {
    t16 = $[12];
  }
  let t17;
  if ($[13] !== is2MobileColumns) {
    t17 = <div className="items-center flex h-full" role="button" tabIndex="0" onClick={() => {
      setMobileColumnsAcross(is2MobileColumns ? 1 : 2);
    }}>{is2MobileColumns ? <IconMobileGrid2x /> : <IconMobileGrid1x />}</div>;
    $[13] = is2MobileColumns;
    $[14] = t17;
  } else {
    t17 = $[14];
  }
  let t18;
  if ($[15] !== className) {
    t18 = classNames("lg:mt-10 lg:mb-10", className);
    $[15] = className;
    $[16] = t18;
  } else {
    t18 = $[16];
  }
  let t19;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = getTabId("Listed", "PDPFullScreenGallery");
    $[17] = t19;
  } else {
    t19 = $[17];
  }
  const t20 = selectedTab !== "Listed" ? true : undefined;
  let t21;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = getTabContentId("Listed", "PDPFullScreenGallery");
    $[18] = t21;
  } else {
    t21 = $[18];
  }
  let t22;
  if ($[19] !== displayShownIn || $[20] !== enableCrops || $[21] !== galleryRef || $[22] !== is2MobileColumns || $[23] !== isEditOrder || $[24] !== isMobileOrTablet || $[25] !== mobileColumnsAcross || $[26] !== onClose || $[27] !== pdpIsModularBYOProduct || $[28] !== photos || $[29] !== productName || $[30] !== selectedTab) {
    t22 = selectedTab === "Listed" && <div ref={galleryRef} className={classNames("grid lg:gap-8", {
      "gap-[.5rem] grid-cols-[repeat(auto-fit,minmax(90%,1fr))]": mobileColumnsAcross !== 2,
      "!gap-[2px] !grid-cols-[repeat(auto-fit,minmax(45%,1fr))]": mobileColumnsAcross === 2
    })}>{photos.map((t23, photoIndex) => {
        const {
          src,
          id,
          type,
          optionId,
          valueId,
          upholsteryName,
          cropData,
          product_name: t24
        } = t23;
        const product_name = t24 === undefined ? "" : t24;
        return <PDPFullScreenGalleryListItem key={id} isEditOrder={isEditOrder} enableCrops={enableCrops} type={type} src={src} is2MobileColumns={is2MobileColumns} isMobile={isMobileOrTablet} onClick={() => {
          if (isMobileOrTablet) {
            setPinchGalleryIndex(photoIndex);
            setIsPinchGalleryOpen(true);
          }
        }} optionId={optionId} valueId={valueId} upholsteryName={upholsteryName} closeFullScreenGallery={onClose} cropData={cropData} productName={pdpIsModularBYOProduct ? product_name : displayShownIn ? productName : null} displayShownIn={displayShownIn} />;
      })}</div>;
    $[19] = displayShownIn;
    $[20] = enableCrops;
    $[21] = galleryRef;
    $[22] = is2MobileColumns;
    $[23] = isEditOrder;
    $[24] = isMobileOrTablet;
    $[25] = mobileColumnsAcross;
    $[26] = onClose;
    $[27] = pdpIsModularBYOProduct;
    $[28] = photos;
    $[29] = productName;
    $[30] = selectedTab;
    $[31] = t22;
  } else {
    t22 = $[31];
  }
  let t23;
  if ($[32] !== t20 || $[33] !== t22) {
    t23 = <div aria-labelledby={t19} hidden={t20} id={t21} role="tabpanel">{t22}</div>;
    $[32] = t20;
    $[33] = t22;
    $[34] = t23;
  } else {
    t23 = $[34];
  }
  let t24;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = getTabId("Grid", "PDPFullScreenGallery");
    $[35] = t24;
  } else {
    t24 = $[35];
  }
  const t25 = selectedTab !== "Grid" ? true : undefined;
  let t26;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = getTabContentId("Grid", "PDPFullScreenGallery");
    $[36] = t26;
  } else {
    t26 = $[36];
  }
  let t27;
  if ($[37] !== enableCrops || $[38] !== mobileColumnsAcross || $[39] !== photos || $[40] !== selectedTab) {
    t27 = selectedTab === "Grid" && <div className={classNames("grid gap-6 grid-cols-[repeat(auto-fill,minmax(11rem,1fr))]", {
      "!gap-[2px] !grid-cols-[repeat(auto-fit,minmax(45%,1fr))]": mobileColumnsAcross === 2
    })}>{photos.map((t28, photoIndex_0) => {
        const {
          src: src_0,
          id: id_0,
          type: type_0,
          cropData: cropData_0
        } = t28;
        return <RatioContainer key={id_0}><JBProductImage className="block rounded-sm cursor-pointer" src={src_0} sizes="100vw" enableCrops={enableCrops} type={type_0} ar="1:1" cropFormat="1x1" crops={cropData_0} onClick={() => {
            setSelectedDesktopTab("Listed");
            setSelectedPhotoIndex(photoIndex_0);
          }} size="10vw" /></RatioContainer>;
      })}</div>;
    $[37] = enableCrops;
    $[38] = mobileColumnsAcross;
    $[39] = photos;
    $[40] = selectedTab;
    $[41] = t27;
  } else {
    t27 = $[41];
  }
  let t28;
  if ($[42] !== t25 || $[43] !== t27) {
    t28 = <div aria-labelledby={t24} hidden={t25} id={t26} role="tabpanel">{t27}</div>;
    $[42] = t25;
    $[43] = t27;
    $[44] = t28;
  } else {
    t28 = $[44];
  }
  let t29;
  if ($[45] !== isEditOrder || $[46] !== isMobileOrTablet || $[47] !== isPinchGalleryOpen || $[48] !== onClose || $[49] !== photos || $[50] !== pinchGalleryIndex) {
    t29 = isMobileOrTablet && <><PDPPinchToZoomGallery isEditOrder={isEditOrder} isOpen={isPinchGalleryOpen} onClose={closeGallery => {
        setIsPinchGalleryOpen(false);
        if (closeGallery) {
          onClose();
        }
      }} photos={photos} selectedPhotoIndex={pinchGalleryIndex} setSelectedPhotoIndex={setPinchGalleryIndex} />{!isPinchGalleryOpen && <SnackbarShowOnce storageKey="tapToZoomInAndSeeTheMaterial">Tap to zoom in and<br />see the material.</SnackbarShowOnce>}</>;
    $[45] = isEditOrder;
    $[46] = isMobileOrTablet;
    $[47] = isPinchGalleryOpen;
    $[48] = onClose;
    $[49] = photos;
    $[50] = pinchGalleryIndex;
    $[51] = t29;
  } else {
    t29 = $[51];
  }
  let t30;
  if ($[52] !== t18 || $[53] !== t23 || $[54] !== t28 || $[55] !== t29) {
    t30 = <FixedWidthContainer className={t18} noMobilePadding={true}>{t23}{t28}{t29}</FixedWidthContainer>;
    $[52] = t18;
    $[53] = t23;
    $[54] = t28;
    $[55] = t29;
    $[56] = t30;
  } else {
    t30 = $[56];
  }
  let t31;
  if ($[57] !== isOpen || $[58] !== isPinchGalleryOpen || $[59] !== onClose || $[60] !== t15 || $[61] !== t16 || $[62] !== t17 || $[63] !== t30) {
    t31 = <FullScreenModal isOpen={isOpen} onClose={onClose} headerLeft={t15} mobileNoPadding={true} mobileHeaderCenter={t16} mobileHeaderRight={t17} mobileHeaderNoPointerEvents={isPinchGalleryOpen}>{t30}</FullScreenModal>;
    $[57] = isOpen;
    $[58] = isPinchGalleryOpen;
    $[59] = onClose;
    $[60] = t15;
    $[61] = t16;
    $[62] = t17;
    $[63] = t30;
    $[64] = t31;
  } else {
    t31 = $[64];
  }
  return t31;
};
PDPFullScreenGallery.propTypes = {
  className: PropTypes.string,
  displayShownIn: PropTypes.bool,
  enableCrops: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
  initialSelectedPhotoIndex: PropTypes.number,
  isEditOrder: PropTypes.bool,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  photos: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    id: PropTypes.string,
    src: PropTypes.string
  })),
  productName: PropTypes.string,
  showGridView: PropTypes.bool
};
export default withBrowserOnly(PDPFullScreenGallery);